var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgRec = function SvgRec(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm2.167-13.556h-3.456v-1.851h3.261v-1.26h-3.261v-1.777h3.456v-1.361h-5.052v7.61h5.052v-1.361zM23.087 20c1.839 0 3.181-1.134 3.313-2.779h-1.554c-.153.838-.84 1.376-1.754 1.376-1.205 0-1.95-.997-1.95-2.6s.745-2.595 1.945-2.595c.909 0 1.601.575 1.754 1.45h1.554c-.116-1.656-1.501-2.853-3.308-2.853-2.214 0-3.578 1.524-3.578 3.997 0 2.479 1.369 4.003 3.578 4.003zM7.196 17.047h1.305l1.422 2.758h1.807l-1.607-3.006c.877-.348 1.385-1.192 1.385-2.162 0-1.514-1.03-2.442-2.706-2.442H5.6v7.61h1.596v-2.758zm0-3.565v2.341h1.4c.803 0 1.274-.432 1.274-1.165 0-.722-.497-1.176-1.289-1.176H7.196z"
  })));
};

export default SvgRec;